import { createContext, useContext } from "react";
const SectionTabsContext = createContext({});
function useSectionTabs() {
  return useContext(SectionTabsContext);
}
const ActiveSectionsTabsContext = createContext({});
function useActiveSectionsTabs() {
  return useContext(ActiveSectionsTabsContext);
}
const SectionTabsRegistrationContext = createContext([
  (tab) => {
  },
  (tab) => {
  }
]);
function useSectionTabsRegistration() {
  return useContext(SectionTabsRegistrationContext);
}
export {
  ActiveSectionsTabsContext,
  SectionTabsContext,
  SectionTabsRegistrationContext,
  useActiveSectionsTabs,
  useSectionTabs,
  useSectionTabsRegistration
};
//# sourceMappingURL=Context.js.map
